// extracted by mini-css-extract-plugin
export var content = "_sq-1";
export var wrapper = "_sq-0";